const TOKEN_KEY = "token";
const SESSION_KEY = "admin_session";

/**
 * Decode a JWT payload without verifying the signature.
 * Used only for the legacy header-token flow.
 */
function decodeTokenPayload(token) {
  try {
    const payload = token.split(".")[1];
    if (!payload) return null;
    const decoded = JSON.parse(atob(payload.replace(/-/g, "+").replace(/_/g, "/")));
    return decoded;
  } catch {
    return null;
  }
}

export const login = () => {
  localStorage.setItem(TOKEN_KEY, "TestLogin");
};

export const logout = () => {
  localStorage.clear();
};

export const isLogin = () => {
  // Check legacy header token (still supported for backward compat)
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    const payload = decodeTokenPayload(token);
    if (payload && payload.exp && payload.role) {
      if (Date.now() / 1000 > payload.exp) {
        localStorage.removeItem(TOKEN_KEY);
      } else if (payload.role === "admin" || payload.role === "user") {
        return true;
      }
    }
  }

  // Check session flag set after HttpOnly cookie login
  const session = localStorage.getItem(SESSION_KEY);
  if (!session) return false;

  try {
    const { exp, role } = JSON.parse(session);
    if (Date.now() / 1000 > exp) {
      localStorage.removeItem(SESSION_KEY);
      return false;
    }
    return role === "admin" || role === "user";
  } catch {
    localStorage.removeItem(SESSION_KEY);
    return false;
  }
};

export const setAdminSession = (role, location) => {
  const exp = Math.floor(Date.now() / 1000) + 14400; // 4 hours, matches cookie
  localStorage.setItem(SESSION_KEY, JSON.stringify({ role, location, exp }));
};

export const clearAdminSession = () => {
  localStorage.removeItem(SESSION_KEY);
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem("role");
  localStorage.removeItem("location");
  localStorage.removeItem("user_id");
};
